import { IDichVuSelectRequest } from '../../models/request/dich-vu/dichVuRequests';
import { KhoanNopStatusItemResponse } from '../../models/response/dich-vu/sf_khoannop_group';
import { sf_saleset_register_dichvu } from '../../models/response/dich-vu/sf_saleset_register_dichvu';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_SALESET_REGISTER_DICHVU_PATH = "sf-saleset-register-dichvu";

/** Body của `sf-saleset-register-dichvu/insert-multiple` */
export interface ISaleSetRegisterDichVuInsertMultipleRequest {
	list_khoannop_group: KhoanNopStatusItemResponse[];
	ts_hocsinh_id: number;
	nam_hoc: string;
}

/** Body của `sf-saleset-register-dichvu/insert-multiple-by-namhoc` */
export interface ISaleSetRegisterDichVuInsertMultipleByNamHocRequest {
	nam_hoc: string;
	dm_coso_id?: number;
	[key: string]: any;
}

class SaleSetRegisterDichVuApi extends BaseCRUDApi<sf_saleset_register_dichvu> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByCoSo(request: IDichVuSelectRequest) {
		return apiClient.post(`sf-saleset-register-dichvu/select/by/coso`, request);
	}
	Detail(id: number) {
		return apiClient.get(`${API_SALESET_REGISTER_DICHVU_PATH}/${id}`);
	}
	InsertMultiple(request: ISaleSetRegisterDichVuInsertMultipleRequest) {
		return apiClient.post(`sf-saleset-register-dichvu/insert-multiple`, request);
	}
	InsertMultipleByNamHoc(request: ISaleSetRegisterDichVuInsertMultipleByNamHocRequest) {
		return apiClient.post(`sf-saleset-register-dichvu/insert-multiple-by-namhoc`, request);
	}
}
export const saleSetRegisterDichVuApi = new SaleSetRegisterDichVuApi(API_SALESET_REGISTER_DICHVU_PATH);
